module.exports = __webpack_public_path__ + "static/img/alrajhi-bank.838fc55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-img/alrajhi-bank.png
// module id = 1146
// module chunks = 4